<template>
  <b-modal
    :active="Boolean(document)"
    scroll="keep"
    :width="440"
    :can-cancel="['escape']"
    @close="$emit('close')"
  >
    <div v-if="document" class="modal-card">
      <header class="modal-card-head is-danger">
        <p class="modal-card-title">
          Removing Document
        </p>
      </header>
      <section class="modal-card-body">
        <p>
          Are you sure you want to remove <b>{{ document.label }}</b
          >?
        </p>
        <template v-if="document.pending_authorizations.length">
          <p>
            Removing this document will prevent suppliers from accessing it for
            the following pending authorizations:
          </p>
          <ul>
            <li
              v-for="auth in document.pending_authorizations"
              :key="auth.supplier_name"
            >
              <b>{{ auth.supplier_name }}</b> created on
              {{ getDate(auth.created_at) }}
            </li>
          </ul>
        </template>
      </section>
      <footer class="modal-card-foot">
        <b-button outlined @click="$emit('close')">
          Cancel
        </b-button>
        <b-button type="is-danger" @click="$emit('confirm')">
          Remove Document
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import DateTimeMixin from "@/mixins/dateTime";

export default {
  mixins: [DateTimeMixin],
  props: {
    document: {
      type: Object,
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
p + p {
  margin-top: 10px;
}
ul {
  list-style: disc;
  margin-top: 10px;
  padding-left: 20px;
}
</style>
